module.exports = __webpack_public_path__ + "img/coins-icons-v2-bsc-pool1.fc4d182f.svg";